const $filterRooms = document.getElementById( 'contract-filters' );
const $startDateFilter = document.getElementById( 'startDateFilter' );
const $contractLengthFilter = document.getElementById( 'contractLengthFilter' );
const $startDateFilterValue = document.getElementById( 'startDateFilterValue' );
const $contractLengthFilterValue = document.getElementById( 'contractLengthFilterValue' );
const $clearFilter = document.querySelector( '.kaplan-room-filters__clear' );

/**
 * Show the selected option's label in the collapsed/pinned filter state.
 *
 * @param {HTMLSelectElement} $select Select element.
 * @param {HTMLElement} $value Element that mirrors the selected option's label.
 */
function updateFilterValue( $select, $value ) {
	if ( $select.value === '' ) {
		$value.textContent = '';
		return;
	}

	$value.textContent = $select.options[ $select.selectedIndex ].textContent;
}

/**
 * "Clear filter" should only be visible while at least one filter is applied.
 */
function updateClearFilterVisibility() {
	$clearFilter.hidden = $startDateFilter.value === '' && $contractLengthFilter.value === '';
}

/**
 * Remove every dynamically-added contract length option, keeping the placeholder.
 */
function clearContractLengthOptions() {
	document.querySelectorAll( '#contractLengthFilter option' ).forEach( ( option, index ) => {
		if ( index > 0 ) {
			option.remove();
		}
	} );
}

const roomDataSelectors = {
	'availability': '.kaplan-room-card-dates__availability-status',
	'buttonBook': '.kaplan-room-card-booking .button--primary',
	'buttonWait': '.kaplan-room-card-booking .button--secondary',
	'endDate': '.kaplan-room-card-dates__end-date p',
	'priceFrom': '.kaplan-room-card-pricing__from',
	'pricePerWeek': '.kaplan-room-card-pricing__price',
	'total': '.kaplan-room-card-pricing__total',
	'totalPrice': '.kaplan-room-card-pricing__total p:last-child',
	'startDate': '.kaplan-room-card-dates__start-date p',
	'weeks': '.kaplan-room-card-pricing__total p:first-child span:nth-of-type(1)',
	'weeksFrom': '.kaplan-room-card-pricing__total p:first-child span:nth-of-type(2)',
};

/**
 * Dynamically update contract length field options when changing start date.
 */
$startDateFilter.addEventListener( 'change', ( event ) => {
	const startDateValue = event.target.value;

	clearContractLengthOptions();

	updateFilterValue( $startDateFilter, $startDateFilterValue );
	// The options were just cleared above, so the contract length value is always blank here.
	$contractLengthFilterValue.textContent = '';
	updateClearFilterVisibility();

	if ( startDateValue === '' ) {
		return;
	}

	// Populate with options from filter list.
	for ( const [ key, value ] of Object.entries( window.kaplanRoomListFilters[ startDateValue ].durations ) ) {
		let el = document.createElement( 'option' );
		el.text = value;
		el.value = key;
		$contractLengthFilter.add( el );
	}
} );

/**
 * Add filters values to the URL.
 */
$contractLengthFilter.addEventListener( 'change', ( event ) => {
	updateFilterValue( $contractLengthFilter, $contractLengthFilterValue );
	updateClearFilterVisibility();

	if ( $startDateFilter.value === '' ) {
		return;
	}

	const contractLengthValue = event.target.value;

	if ( contractLengthValue === '' ) {
		return;
	}

	if ( window.history.pushState ) {
		window.history.pushState( null, null, '?startdate=' + $startDateFilter.value + '&contractlength=' + contractLengthValue );
	}
} );

// Artificially high price so it's appended at the end.
const UNDEFINED_SORTING_PRICE = 9999;

/**
 * Handle the rooms filter form on submit.
 */
$filterRooms.addEventListener( 'submit', ( event ) => {
	event.preventDefault();

	if ( $startDateFilter.value === '' ) {
		alert( 'Please select a start date' );
		return;
	}

	if ( $contractLengthFilter.value === '' ) {
		alert( 'Please select a contract length' );
		return;
	}

	window.kaplanRoomList.forEach( ( room ) => {
		const $roomCard = document.getElementById( `room-${room.roomTypeID}-${room.roomLocationID}` );

		// Reset data
		resetRoomData( $roomCard );

		const $startDate = $roomCard.querySelector( roomDataSelectors.startDate );
		const $endDate = $roomCard.querySelector( roomDataSelectors.endDate );
		const $priceFrom = $roomCard.querySelector( roomDataSelectors.priceFrom );
		const $pricePerWeek = $roomCard.querySelector( roomDataSelectors.pricePerWeek );
		const $total = $roomCard.querySelector( roomDataSelectors.total );
		const $weeks = $roomCard.querySelector( roomDataSelectors.weeks );
		const $weeksFrom = $roomCard.querySelector( roomDataSelectors.weeksFrom );
		const $totalPrice = $roomCard.querySelector( roomDataSelectors.totalPrice );
		const $availability = $roomCard.querySelector( roomDataSelectors.availability );
		const $buttonBook = $roomCard.querySelector( roomDataSelectors.buttonBook );
		const $buttonWait = $roomCard.querySelector( roomDataSelectors.buttonWait );
		const formatter = new Intl.NumberFormat( 'en-GB', {
			style: 'decimal',
		} );

		if ( ! ( $startDateFilter.value in room.contracts ) ) {
			$pricePerWeek.innerText = '£—';
			return;
		}

		// Room contract has a matching duration.
		const validContracts = room.contracts[ $startDateFilter.value ].filter( ( contract ) => {
			return contract?.ContractDuration === parseInt( $contractLengthFilter.value, 10 );
		} ) || [];

		if ( validContracts.length === 0 ) {
			return;
		}

		// All contracts have some shared data e.g. start/end/duration.
		const contract = validContracts[0];

		// Display dates
		$startDate.innerText = contract.ContractDateStartLabel;
		$endDate.innerText = contract.ContractDateEndLabel;

		// Display prices
		$weeks.innerText = contract.ContractDuration;

		// Get room availability from API.
		update_from_room_availability( room, contract )
			.then( response => {
				const code_limited = 'limited';
				const code_available = 'available';
				const code_soldout = 'sold-out';

				const responseCode = response.data.code;

				// Response code validation.
				if ( ! [ code_available, code_limited, code_soldout ].includes( responseCode ) ) {
					return;
				}

				// Find the lowest price contract from the room types we found availability for
				// based on the current valid contracts.
				const lowestPrices = validContracts.reduce( ( carry, contract ) => {
					if ( ! carry[ contract.RoomTypeID ] || carry[ contract.RoomTypeID ] > contract.AmountExtra ) {
						carry[ contract.RoomTypeID ] = contract.AmountExtra;
					}
					return carry;
				}, {} );
				const lowestPrice = response.data.types.reduce( ( price, roomType ) => {
					return ( lowestPrices[ roomType ] || UNDEFINED_SORTING_PRICE ) < price ? lowestPrices[ roomType ] : price;
				}, UNDEFINED_SORTING_PRICE );

				$pricePerWeek.innerText = '£' + formatter.format( lowestPrice );
				$totalPrice.innerText = '£' + formatter.format( lowestPrice * contract.ContractDuration );
				$priceFrom.classList.toggle( 'kaplan-room-card-pricing__from--is-hidden', response.data.types.length < 2 );
				$weeksFrom.classList.toggle( 'kaplan-room-card-pricing__from--is-hidden', response.data.types.length < 2 );
				$total.classList.add( 'kaplan-room-card-pricing__total--is-shown' );

				$roomCard.dataset.sortingPrice = lowestPrice.toString();

				switch ( responseCode ) {
					case code_available:
						// Available status beats others.
						$availability.classList.value = 'kaplan-room-card-dates__availability-status--is-available';
						$buttonBook.classList.add( 'button--is-visible' );
						$buttonBook.href = response.data.link;
						$buttonWait.classList.remove( 'button--is-visible' );

						break;

					case ( code_limited ) :
						if ( [ code_available ].includes( $availability.dataset.availabilityCode ) ) {
							// Limited status beats sold out.
							return;
						}
						$availability.classList.value = 'kaplan-room-card-dates__availability-status--is-limited';
						$buttonBook.classList.add( 'button--is-visible' );
						$buttonBook.href = response.data.link;
						$buttonWait.classList.remove( 'button--is-visible' );
						break;

					case code_soldout :
						if ( [ code_available, code_limited ].includes( $availability.dataset.availabilityCode ) ) {
							// Sold out is beat by any other status.
							return;
						}
						$availability.classList.value = 'kaplan-room-card-dates__availability-status--is-sold-out';
						$buttonBook.href = null;
						$buttonWait.classList.add( 'button--is-visible' );
						break;
					default:
						// Can't get here if our validation works.
						return;
				}

				$availability.classList.add( 'kaplan-room-card-dates__availability-status' );
				$availability.dataset.availabilityCode = responseCode;
				$availability.innerHTML = response.data.label;

				// Reappend all rooms as each price is returned.
				appendBySortedPrice();
			} );
	} );
} );

/**
 * Handle the rooms filter form on reset.
 */
$filterRooms.addEventListener( 'reset', () => {
	window.kaplanRoomList.forEach( ( room ) => {
		const $roomCard = document.getElementById( `room-${room.roomTypeID}-${room.roomLocationID}` );
		resetRoomData( $roomCard );
	} );

	// Native `reset` doesn't clear the contract length options we added dynamically.
	clearContractLengthOptions();

	$startDateFilterValue.textContent = '';
	$contractLengthFilterValue.textContent = '';

	// The native reset of the select values happens after the `reset` event
	// finishes dispatching, so check visibility on the next tick — otherwise
	// this reads the pre-reset (still selected) values and leaves the button visible.
	setTimeout( updateClearFilterVisibility, 0 );
} );

/**
 *
 * @param {HTMLElement} $availability Availability element.
 */
function resetAvailabilityElm( $availability ) {
	$availability.classList.remove( 'kaplan-room-card-dates__availability-status--is-available' );
	$availability.classList.remove( 'kaplan-room-card-dates__availability-status--is-sold-out' );
	$availability.classList.remove( 'kaplan-room-card-dates__availability-status--is-limited' );
	delete $availability.dataset.availabilityCode;
}

/**
 * Reset room card data.
 * Happens:
 * - On filter reset.
 * - On filter change before room card data update.
 *
 * @param {HTMLElement} $roomCard Room card element.
 */
function resetRoomData( $roomCard ) {
	const $startDate = $roomCard.querySelector( roomDataSelectors.startDate );
	const $endDate = $roomCard.querySelector( roomDataSelectors.endDate );
	const $pricePerWeek = $roomCard.querySelector( roomDataSelectors.pricePerWeek );
	const $priceFrom = $roomCard.querySelector( roomDataSelectors.priceFrom );
	const $total = $roomCard.querySelector( roomDataSelectors.total );
	const $weeks = $roomCard.querySelector( roomDataSelectors.weeks );
	let $weeksFrom = $roomCard.querySelector( roomDataSelectors.weeksFrom );
	const $totalPrice = $roomCard.querySelector( roomDataSelectors.totalPrice );
	const $availability = $roomCard.querySelector( roomDataSelectors.availability );
	const $buttonBook = $roomCard.querySelector( roomDataSelectors.buttonBook );
	const $buttonWait = $roomCard.querySelector( roomDataSelectors.buttonWait );

	// Back compat for weeks from span.
	if ( ! $weeksFrom ) {
		$weeksFrom = document.createElement( 'span' );
		$weeksFrom.innerText = ' from';
		$total.firstElementChild.appendChild( $weeksFrom );
	}

	// Show card (if hidden).
	$roomCard.classList.remove( 'kaplan-room-card--is-hidden' );
	$roomCard.dataset.sortingPrice = String( UNDEFINED_SORTING_PRICE );

	// Hide buttons
	$buttonBook.classList.remove( 'button--is-visible' );
	$buttonWait.classList.remove( 'button--is-visible' );

	// remove href.
	$buttonBook.href = '';

	// Remove dates.
	$startDate.innerText = '—';
	$endDate.innerText = '—';
	$availability.innerText = '—';

	// Remove classes.
	resetAvailabilityElm( $availability );

	// Remove prices.
	$weeks.innerText = '—';
	$weeksFrom.classList.add( 'kaplan-room-card-pricing__from--is-hidden' );
	if ( $pricePerWeek.getAttribute( 'data-lowest-price' ) ) {
		$pricePerWeek.innerText = '£' + $pricePerWeek.getAttribute( 'data-lowest-price' );
	} else {
		$pricePerWeek.innerText = '£—';
	}

	$totalPrice.innerText = '£—';
	$priceFrom.classList.remove( 'kaplan-room-card-pricing__from--is-hidden' );
	$total.classList.remove( 'kaplan-room-card-pricing__total--is-shown' );
}

/**
 *
 */
function appendBySortedPrice() {
	const $roomList = document.querySelector( '.wp-block-kaplan-room-list.sort-default' );
	if ( typeof $roomList === 'undefined' || $roomList === null ) {
		// Uses custom sorting
		return;
	}

	// Sort by lowest price.
	const $roomCards = document.querySelectorAll( '.wp-block-kaplan-room-card' );
	if ( typeof $roomCards === 'undefined' || $roomCards === null ) {
		return;
	}
	let roomList = Array.prototype.slice.call( $roomCards, 0 );
	roomList = roomList.sort( ( a, b ) => {
		return Number( a.dataset.sortingPrice ) - Number( b.dataset.sortingPrice );
	} );

	// Reappend.
	const $parent = $roomCards[0].parentNode;
	roomList.forEach( ( $roomCard ) => {
		$parent.appendChild( $roomCard );
	} );
}

/**
 * Find the lowest price to display on each room card.
 */
function defineLowestPrice() {
	if ( typeof window.kaplanRoomList == 'undefined' || window.kaplanRoomList == null ) {
		return;
	}

	window.kaplanRoomList.forEach( ( room ) => {
		const $roomCard = document.getElementById( `room-${room.roomTypeID}-${room.roomLocationID}` );
		if ( typeof $roomCard === 'undefined' || $roomCard === null ) {
			return;
		}

		const $pricePerWeek = $roomCard.querySelector( '.kaplan-room-card-pricing__price' );
		$pricePerWeek.innerText = '£—';
		let lowestPrice = 0;
		let lowestPrices = {};

		// Loop through the contracts.
		for ( const contracts of Object.values( room.contracts ) ) {
			for ( const contract of contracts ) {
				if ( lowestPrice === 0 || contract.AmountExtra < lowestPrice ) {
					lowestPrice = contract.AmountExtra;
				}
				if ( ! lowestPrices[ contract.RoomTypeID ] || contract.AmountExtra < lowestPrices[ contract.RoomTypeID ] ) {
					lowestPrices[ contract.RoomTypeID ] = contract.AmountExtra;
				}
			}
		}

		if ( lowestPrice !== 0 ) {
			$pricePerWeek.innerText = '£' + lowestPrice;
			$pricePerWeek.dataset.lowestPrice = lowestPrice.toString();
		}

		let sortingPrice = lowestPrice;
		if ( lowestPrice === 0 ) {
			// Artificially high price so it's appended at the end.
			sortingPrice = UNDEFINED_SORTING_PRICE;
		}

		$roomCard.dataset.sortingPrice = sortingPrice.toString();
		$roomCard.lowestPrices = lowestPrices;
	} );

	appendBySortedPrice();
}

defineLowestPrice();

// The availability endpoint's stale-while-revalidate cache is populated by a
// separate scheduled PHP request, so on a cache miss we wait and re-poll from a
// fresh request rather than retrying in the same one. Capped so a cache that
// never populates (e.g. an environment without the scheduled task running)
// can't lock up the page.
const AVAILABILITY_MAX_RETRIES = 3;
const AVAILABILITY_RETRY_DELAY_MS = 2000;

/**
 * Get room availability from API.
 *
 * @param {object} room Room data.
 * @param {object} contract Contract data.
 * @param {number} retriesLeft Remaining re-poll attempts on an empty cache.
 * @returns {Promise} The JSON response if successful.
 */
function update_from_room_availability( room, contract, retriesLeft = AVAILABILITY_MAX_RETRIES ) {
	const ajaxurl = $filterRooms.getAttribute( 'action' );
	const nonce = $filterRooms.getAttribute( 'data-nonce' );

	const data = {
		'action': 'kaplan_get_room_availability',
		'nonce': nonce,
		'room_post_id': room.postID,
		'start_date': contract.ContractDateStart,
		'end_date': contract.ContractDateEnd,
		'term_type_id': contract.TermTypeID,
	};

	const url = new URL( ajaxurl );
	url.search = new URLSearchParams( data ).toString();

	return fetch( url, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			'Cache-Control': 'max-age=60',
		},
	} )
		.then( response => response.json() )
		.then( data => {
			// Wait (without blocking the main thread) before re-polling; give up
			// gracefully once retries run out.
			if ( ! data.success && data.data === 'empty_cache' && retriesLeft > 0 ) {
				return new Promise( resolve => setTimeout( resolve, AVAILABILITY_RETRY_DELAY_MS ) )
					.then( () => update_from_room_availability( room, contract, retriesLeft - 1 ) );
			}

			return data;
		} );
}

// Autoload rooms based on GET parameters.
window.addEventListener( 'DOMContentLoaded', ( event ) => {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams( queryString );

	// If StartDate is set, populate the Contracts Length.
	if ( urlParams.get( 'startdate' ) !== null ) {
		let e = new Event( 'change' );
		$startDateFilter.value = urlParams.get( 'startdate' );
		$startDateFilter.dispatchEvent( e );

		// Select the contract set in the GET parameter.
		$contractLengthFilter.value = urlParams.get( 'contractlength' );
		updateFilterValue( $contractLengthFilter, $contractLengthFilterValue );
		updateClearFilterVisibility();

		// Filter the results.
		e = new Event( 'submit', { cancelable: true } );
		$filterRooms.dispatchEvent( e );

		// Check if the url has a hash and move it to the specific room.
		if ( window.location.hash ) {
			const targetElement = document.querySelector( window.location.hash );
			if ( targetElement !== null ) {
				targetElement.scrollIntoView( { behavior: 'smooth' } );
			}
		}
	}
} );
